export const AREA_OF_LAW_CATEGORIES: { categoryName: string; choices: string[] }[] = [
  {
    categoryName: 'Business license, fees, etc.',
    choices: [
      'Business license, fees, etc.',
      'Patents',
      'Franchise Law',
      'Trademarks',
      'Entertainment',
      'Corporate',
      'Patent Copyright',
      'Copyright',
    ],
  },
  { categoryName: 'Civil Litigation', choices: ['Civil Litigation', 'Small Claims'] },
  { categoryName: 'Collection', choices: ['Collection'] },
  {
    categoryName: 'Consumer/Finance',
    choices: [
      'Consumer/Finance',
      'Bankruptcy',
      'Insurance',
      'Banking',
      'Identity Theft',
      'Billing Disputes',
      'Affidavit',
      'Credit Reports and Repair',
      'Loan Modification',
      'Product Liability',
      'Tax',
      'Vehicle Financing Issues',
      'Repossession',
      'Pay Day Loans/Title Loans',
    ],
  },
  { categoryName: 'Contract', choices: ['Contract', 'Promissory Notes'] },
  { categoryName: 'Criminal', choices: ['Criminal', 'Domestic Violence', 'Firearm'] },
  {
    categoryName: 'Employment',
    choices: [
      'Employment',
      'Garnishment',
      'Military Law/Security Clearance',
      'Federal Workers Comp',
      'Administrative Law',
      'Labor Law',
      "Worker's Compensation",
      "Veteran's Affairs",
      'Social Security',
      'Public Service',
    ],
  },
  {
    categoryName: 'Estate Planning',
    choices: ['Estate Planning', 'Codicils', 'Power of Attorney', 'Special Needs Trust', 'Will', 'Trust', 'Probate'],
  },
  {
    categoryName: 'Family Law',
    choices: [
      'Family Law',
      'Child Support Issues',
      'Child Guardianship/Custody/Vis',
      'Guardianship/Conservatorship',
      'Name Change',
      'Divorce Uncontested',
      'Divorce',
      'Adoption',
      'Juvenile',
      'Elder Law',
      'Prenuptial Agreements',
      'Paternity',
      'Uncontested Adoption',
      'Incompetency Defense',
    ],
  },
  { categoryName: 'General Law', choices: ['General Law', 'Education', 'Legal Malpractice'] },
  { categoryName: 'Immigration', choices: ['Immigration'] },
  { categoryName: 'Landlord Tenant', choices: ['Landlord Tenant'] },
  {
    categoryName: 'Personal Injury',
    choices: ['Personal Injury', 'Medical Malpractice', 'Wrongful Death'],
  },
  {
    categoryName: 'Real Estate',
    choices: [
      'Real Estate',
      'Boundary/Title Disputes',
      'Timeshares',
      'Real Estate Closing',
      'Oil and Gas',
      'Foreclosures',
      'Home Equity Loan',
      'Construction',
      'Mortgage Document Services',
      'Zoning Permits',
      'Refinancing of Home',
      'Deeds',
      'Mineral Rights',
      'Property Tax Assessments',
    ],
  },
  {
    categoryName: 'Traffic',
    choices: ['Traffic', 'Automobile Accident', 'Motor Vehicle Property Damage', "Suspended Driver's License"],
  },
];

export const STATE_CODE_MAP: { state: string; code: string; country: 'US' | 'CA' }[] = [
  { state: 'Alabama', code: 'AL', country: 'US' },
  { state: 'Alaska', code: 'AK', country: 'US' },
  { state: 'Arizona', code: 'AZ', country: 'US' },
  { state: 'Arkansas', code: 'AR', country: 'US' },
  { state: 'California', code: 'CA', country: 'US' },
  { state: 'Colorado', code: 'CO', country: 'US' },
  { state: 'Connecticut', code: 'CT', country: 'US' },
  { state: 'Delaware', code: 'DE', country: 'US' },
  { state: 'District of Columbia', code: 'DC', country: 'US' },
  { state: 'Florida', code: 'FL', country: 'US' },
  { state: 'Georgia', code: 'GA', country: 'US' },
  { state: 'Hawaii', code: 'HI', country: 'US' },
  { state: 'Idaho', code: 'ID', country: 'US' },
  { state: 'Illinois', code: 'IL', country: 'US' },
  { state: 'Indiana', code: 'IN', country: 'US' },
  { state: 'Iowa', code: 'IA', country: 'US' },
  { state: 'Kansas', code: 'KS', country: 'US' },
  { state: 'Kentucky', code: 'KY', country: 'US' },
  { state: 'Louisiana', code: 'LA', country: 'US' },
  { state: 'Maine', code: 'ME', country: 'US' },
  { state: 'Maryland', code: 'MD', country: 'US' },
  { state: 'Massachusetts', code: 'MA', country: 'US' },
  { state: 'Michigan', code: 'MI', country: 'US' },
  { state: 'Minnesota', code: 'MN', country: 'US' },
  { state: 'Mississippi', code: 'MS', country: 'US' },
  { state: 'Missouri', code: 'MO', country: 'US' },
  { state: 'Montana', code: 'MT', country: 'US' },
  { state: 'Nebraska', code: 'NE', country: 'US' },
  { state: 'Nevada', code: 'NV', country: 'US' },
  { state: 'New Hampshire', code: 'NH', country: 'US' },
  { state: 'New Jersey', code: 'NJ', country: 'US' },
  { state: 'New Mexico', code: 'NM', country: 'US' },
  { state: 'New York', code: 'NY', country: 'US' },
  { state: 'North Carolina', code: 'NC', country: 'US' },
  { state: 'North Dakota', code: 'ND', country: 'US' },
  { state: 'Ohio', code: 'OH', country: 'US' },
  { state: 'Oklahoma', code: 'OK', country: 'US' },
  { state: 'Oregon', code: 'OR', country: 'US' },
  { state: 'Pennsylvania', code: 'PA', country: 'US' },
  { state: 'Puerto Rico', code: 'PR', country: 'US' },
  { state: 'Virgin Islands', code: 'VI', country: 'US' },
  { state: 'Guam', code: 'GU', country: 'US' },
  { state: 'Rhode Island', code: 'RI', country: 'US' },
  { state: 'South Carolina', code: 'SC', country: 'US' },
  { state: 'South Dakota', code: 'SD', country: 'US' },
  { state: 'Tennessee', code: 'TN', country: 'US' },
  { state: 'Texas', code: 'TX', country: 'US' },
  { state: 'Utah', code: 'UT', country: 'US' },
  { state: 'Vermont', code: 'VT', country: 'US' },
  { state: 'Virginia', code: 'VA', country: 'US' },
  { state: 'Washington', code: 'WA', country: 'US' },
  { state: 'West Virginia', code: 'WV', country: 'US' },
  { state: 'Wisconsin', code: 'WI', country: 'US' },
  { state: 'Wyoming', code: 'WY', country: 'US' },
  { state: 'Alberta', code: 'AB', country: 'CA' },
  { state: 'British Columbia', code: 'BC', country: 'CA' },
  { state: 'Manitoba', code: 'MB', country: 'CA' },
  { state: 'New Brunswick', code: 'NB', country: 'CA' },
  { state: 'Newfoundland and Labrador', code: 'NL', country: 'CA' },
  { state: 'Nova Scotia', code: 'NS', country: 'CA' },
  { state: 'Ontario', code: 'ON', country: 'CA' },
  { state: 'Prince Edward Island', code: 'PE', country: 'CA' },
  { state: 'Quebec', code: 'QC', country: 'CA' },
  { state: 'Saskatchewan', code: 'SK', country: 'CA' },
  { state: 'Northwest Territory', code: 'NT', country: 'CA' },
  { state: 'Nunavut Territory', code: 'NU', country: 'CA' },
  { state: 'Yukon', code: 'YT', country: 'CA' },
];

export const COUNTRY_OPTIONS = [
  { title: 'United States (incl. Puerto Rico)', value: 'US' },
  { title: 'Canada', value: 'CA' },
];
